export default __webpack_public_path__ + "static/media/ERYC-PEREZ-DE-TAGLE-PHOTOGRAPHY-DINA-MAX-WEDDINGS-NEW-YORK-11162019--617.bc5f2b8d.jpg";